/** Durée maximum d'une vidéo médecin/annonceur */
export const video_max_duration = 30; //seconds
